export default __webpack_public_path__ + "static/media/battery-check.471db51d.png";